var TradeId;
(function (TradeId) {
    TradeId["DUCTWORK_CLEANING"] = "trade_cjdewkmy700021spcbhflstkd";
    TradeId["ELECTRICAL"] = "trade_cjb5j8jga0002k111yy45lq84";
    TradeId["HOME_AUTOMATION"] = "trade_cjdewk1pk00001spcxe38ja5m";
    TradeId["HVAC"] = "trade_cjb5j8hff0001k111fidxbcas";
    TradeId["INSTALLATION"] = "trade_cjdewkush00031spc7polgdgq";
    TradeId["OTHER"] = "trade_cjb5j8p2t0004k11111zswux0";
    TradeId["PLUMBING"] = "trade_cjb5j8m990003k1113vhyyuzo";
    TradeId["PREVENTATIVE_MAINTENANCE"] = "trade_cjdewl7uj00041spcyabb0pyr";
    TradeId["SALES"] = "trade_cjfvhi51q00281enztnl3np7b";
    TradeId["SERVICE"] = "trade_cjn64lazj0000xyyt5p78zjio";
    TradeId["SOLAR"] = "trade_cjdewkgjl00011spcfphrugw1";
})(TradeId || (TradeId = {}));

export { TradeId as T };
